import { CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { Component, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { IProductoData } from '@core/interfaces/entidades/producto.entidad';

@Component({
  selector: 'app-card-producto',
  imports: [CurrencyPipe, NgOptimizedImage],
  templateUrl: './card-producto.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-producto.css',
})
export class CardProducto {
  verImagen = input<boolean>(false);
  producto = input.required<IProductoData>();
  onSelectProducto = output<IProductoData>();

  selectProducto() {
    this.onSelectProducto.emit(this.producto());
  }

  loading = signal(true);

  onImageLoad() {
    console.log('Imagen cargada para producto:', this.producto().codigo);
    this.loading.set(false);
  }

  onImageError() {
    this.loading.set(false);
  }
}
